export enum BackgroundTaskSources {
  IDS = 'ids',
  QUERY = 'query'
}
